export class OrganisationTypeConstants {
  public static readonly DEVELOPER = "Developer";

  public static readonly STANDARD = "Standard";

  public static readonly VERIFIER = "Verifier";

  public static readonly DEVELOPMENT_MANAGER = "DevelopmentManager";

  public static readonly ASSET_MANAGER = "AssetManager";

  public static readonly BADGE = "Badge";

  public static readonly GUEST = "Guest";
}

export type UserType =
  | typeof OrganisationTypeConstants.DEVELOPER
  | typeof OrganisationTypeConstants.VERIFIER
  | typeof OrganisationTypeConstants.DEVELOPMENT_MANAGER
  | typeof OrganisationTypeConstants.ASSET_MANAGER;

export const UserTypeLabels: Record<string, string> = {
  [OrganisationTypeConstants.DEVELOPER]: "Developer",
  [OrganisationTypeConstants.VERIFIER]: "Verifier",
  [OrganisationTypeConstants.DEVELOPMENT_MANAGER]: "Development Manager",
  [OrganisationTypeConstants.ASSET_MANAGER]: "Asset Manager",
};

// GraphQL's OrganisationType enum comes back SCREAMING_SNAKE, which is not what UserTypeLabels is
// keyed on.
export const OrganisationTypeLabels: Record<string, string> = {
  DEVELOPER: "Developer",
  STANDARD: "Standard",
  VERIFIER: "Verifier",
  DEVELOPMENT_MANAGER: "Development Manager",
  ASSET_MANAGER: "Asset Manager",
  BADGE: "Badge",
};
